import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from '@api/core';
import { PatientObjective } from './patient-objective.model';

const API_URL = 'patient_objective';

@Injectable({
  providedIn: 'root'
})

export class PatientObjectiveApiService {
  constructor(private api: ApiService) { }

  dataObjetiveCC?:any

  get(instituteId: string, patientId: number): Observable<PatientObjective> {
    let params = `?patientId=${patientId}&accountId=${instituteId}`;
    return this.api.get(API_URL, params);
  }

  create(objective: PatientObjective): Observable<any> {
    return this.api.post(API_URL, `?patientId=${objective.patientId}`, objective);
  }

  update(objective: PatientObjective): Observable<any> {
    return this.api.put(API_URL, `/${objective.id}?patientId=${objective.patientId}`, objective);
  }
}
